import { Arguments } from 'yargs-parser';

export type Answers = {
  name: string;
  version: string;
};

export type Cmd = {
  name: string;
  alias: string[];
  prepare?: () => void;
  execute: (ctx: { commands: Cmd[]; argv: Arguments }) => void;
  description: string;
};
